export default __webpack_public_path__ + "static/media/refinancing.7f130f5d.jpg";